// extracted by mini-css-extract-plugin
module.exports = {"footerAction":"NewForm_footerAction__znVkm","wrapper":"NewForm_wrapper__3cOOw"};